// Daily allowances follow UTC dates, regardless of the browser's local timezone.
export function nextDailyCreditReset(now = new Date()) {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)).toISOString();
}

export function buildDailyCreditWindow(profile, now = new Date()) {
  const grantedAt = profile.freeDailyCreditsResetAt ? new Date(profile.freeDailyCreditsResetAt) : null;
  return {
    periodUtc: grantedAt && Number.isFinite(grantedAt.getTime()) ? grantedAt.toISOString().slice(0, 10) : null,
    quota: Math.max(0, Number(profile.dailyFreeQuota) || 0),
    grantedAt: grantedAt && Number.isFinite(grantedAt.getTime()) ? grantedAt.toISOString() : null,
    nextResetAt: nextDailyCreditReset(now),
  };
}

export function dailyCreditNoticeKey(userId) {
  return `botgo:daily-credit-notice:v1:${userId}`;
}

export function shouldShowDailyCreditNotice(credits, acknowledgedPeriod, now = new Date()) {
  const window = credits?.dailyCreditWindow;
  return Boolean(
    credits?.userId && window?.quota > 0 &&
    window.periodUtc === now.toISOString().slice(0, 10) &&
    acknowledgedPeriod !== window.periodUtc
  );
}

export function mergeCreditHistory(previous, incoming) {
  const seen = new Set(previous.map(transaction => transaction.id));
  return [...previous, ...incoming.filter(transaction => {
    if (seen.has(transaction.id)) return false;
    seen.add(transaction.id);
    return true;
  })];
}
